import { Loader2 } from "lucide-react";
import { MailModalOverlay } from "@/features/shared/MailModalOverlay";
import type { BulkAttachmentProgress } from "@/lib/mail/bulkMailAttachments";

type Props = {
  open: boolean;
  progress: BulkAttachmentProgress | null;
  title?: string;
};

export function BulkAttachmentProgressModal({
  open,
  progress,
  title = "Traitement des pièces jointes…",
}: Props) {
  const pct =
    progress && progress.total > 0
      ? Math.min(100, Math.round((progress.done / progress.total) * 100))
      : 0;

  return (
    <MailModalOverlay open={open} onClose={() => {}} panelClassName="max-w-sm">
      <div className="px-5 py-6 text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-[var(--mail-accent)]" />
        <p className="mt-3 text-sm font-medium text-[var(--mail-text)]">{title}</p>
        {progress ? (
          <>
            <p className="mt-1 text-xs text-[var(--mail-muted)]">
              {progress.done} / {progress.total}
              {progress.label ? ` — ${progress.label}` : ""}
            </p>
            <div className="mx-auto mt-3 h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-[var(--mail-border-soft)]">
              <div
                className="h-full rounded-full bg-[var(--mail-accent)] transition-all"
                style={{ width: `${pct}%` }}
              />
            </div>
          </>
        ) : null}
      </div>
    </MailModalOverlay>
  );
}
